export default "__VITE_ASSET__C0w3fJKr__"